import { render, staticRenderFns } from "./newUserWhitelist.vue?vue&type=template&id=4af984fe&scoped=true"
import script from "./newUserWhitelist.vue?vue&type=script&lang=js"
export * from "./newUserWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af984fe",
  null
  
)

export default component.exports